import React, { useCallback, useContext } from "react";

import { Button } from "antd";
import { AppContext } from "App";
import { useNavigate } from "react-router-dom";
import { scrollToElement, scrollToTop } from "utils/common";

const StartButtonPricing = ({
    label,
    className,
}: {
    label: string;
    className: string;
}) => {
    const navigate = useNavigate();
    const { isMobile, toggleFormScale, isAuth } = useContext(AppContext);

    const handleStart = useCallback(
        () => {
            if (isMobile) {
                scrollToTop();
                navigate("/sign-up?step=personalInfo");
            } else if (isAuth) {
                scrollToTop();
                navigate("/auth");
            } else {
                toggleFormScale(true);
                scrollToElement("sign-up");
            }
        },
        [isMobile, navigate, toggleFormScale, isAuth]
    );
    return <div className={"horizontal-left w100"}>
        <Button
            size="large"
            type="primary"
            className={className}
            onClick={handleStart}
        >
            {isAuth ? "Profile" : label}
        </Button>
    </div>;
};

export default StartButtonPricing;
